import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { User } from '../../../models/identity/user.model';

@Component({
    selector: 'app-step-header',
    templateUrl: './step-header.component.html',
    styleUrls: ['./step-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepHeaderComponent {

    @Input()
    public user: User;
}
